(function() {
	'use strict';

	angular
		.module('pwc.api')
		.service('API', API);

	API.$inject = ['$http', '$log', 'lodash', 'ENV', 'userPouch', '$q', '$window', 'FileSaver', 'Blob', 'Upload', 'Rollbar'];

	function API($http, $log, lodash, ENV, userPouch, $q, $window, FileSaver, Blob, Upload, Rollbar) {

		/* jshint validthis: true */
		var self = this;

		self.SERVER = ENV.API_URL;

		self.gift = gift;
		self.register = register;
		self.exportWines = exportWines;
		self.recoverPassword = recoverPassword;
		self.resetPassword = resetPassword;
		self.updateCreditCard = updateCreditCard;
		self.cardDetails = cardDetails;
		self.saveFile = saveFile;
		self.getFileUrl = getFileUrl;
		self.userIsActive = userIsActive;

		function getFullEndPoint(endpoint){
			return self.SERVER + '/v1/' + endpoint;
		}

		function userIsActive(username){
			return $http.get(getFullEndPoint('users') + '/' + username + '/isActive');
		}

		function gift(data){
			return $http.post(getFullEndPoint('gifts'), data);
		}

        function recoverPassword(email){

            var data = {
                email: email
            };

            $log.debug('Recovering password for user ', email);

            return $http.post(getFullEndPoint('password/recover'), data);
        }

        function resetPassword(username, password, key){

            var data = {
                username: username,
				password: password,
				key: key
            };

            $log.debug('Recovering password for user ', username);

            return $http.post(getFullEndPoint('password/reset'), data);
        }

		function register(user){

			var data = {
				_id: user._id,
				password: user.password,
				metadata: user.metadata
			};

			$log.debug('Registering user ', lodash.omit(data, 'password'));

			return $http.post(getFullEndPoint('users'), data);
		}

		function cardDetails(username, key){

            var data = {
                username: username,
                key: key
            };

            $log.debug('Getting default card...', data);

            return $http.post(getFullEndPoint('card/details'), data);
		}

        function updateCreditCard(username, key, stripeToken){

            var data = {
                username: username,
                key: key,
                stripeToken: stripeToken
            };

            $log.debug('Updating credit card...');

            return $http.post(getFullEndPoint('card/update'), data);
        }

        function getFileUrl(username, key, file, wineId){

            var data = {
            	wineId: wineId,
                username: username,
                key: key,
                file: file
            };

            $log.debug('Getting secure file...');

            return $http.post(getFullEndPoint('wines/fileUrl'), data);
        }

        function saveFile(username, key, file, wineId){

        	var endpoint = getFullEndPoint('wines/files');

            return Upload.upload({
                url: endpoint,
                method: 'POST',
                sendFieldsAs: "form",
                file: file,
                fields: {
                	wineId: wineId,
                    username: username,
                    key: key
                }
            });
        }

		function exportWines(type, filter){

			return _doAuthorizedPostForActiveUser('export', {"type": type, "filter": filter}, {
				responseType: 'arraybuffer'
			})
			.then(function(response){

				$log.debug('Response', response.headers('Content-Type'));

				var blob = new Blob([response.data], {
					type: response.headers('Content-Type')
				});

				var currentDate = $window.moment().format('YYYY-MM-DD');

				var fileName = 'PWC-wine-export_' + currentDate + '-' + filter + '.' + type;

				FileSaver.saveAs(blob, fileName);
			});
		}

		/**
		 * Sends a post request to the API with active user name & key. Handles decoding of error message if ArrayBuffer response.
		 * @param endpoint
		 * @param data
		 * @param config
		 * @returns {*}
		 * @private
		 */
		function _doAuthorizedPostForActiveUser(endpoint, data, config){

			return userPouch.getActiveUser().then(function(user){

				var username = lodash.get(user, '_id');

				username = username.replace('org.couchdb.user:', '');

				var key = lodash.get(user, 'derived_key');

				data = angular.merge(data, {
					"key": key
				});

				endpoint = 'users/' + username + '/' + endpoint;

				return $http.post(getFullEndPoint(endpoint), data, config);

			}).catch(function(err){

				$log.debug('Post failure.', err);

				var errMsg = 'Unable to process export.';

				if (err.data instanceof ArrayBuffer){

					var decodedString = String.fromCharCode.apply(null, new Uint8Array(err.data));

					var responseObj = angular.fromJson(decodedString);

					errMsg = lodash.get(responseObj, 'error', errMsg);
				}

				if (err.status === -1){
					errMsg = 'Export service unreachable. Are you online?';
				}

                Rollbar.Rollbar.error(err);

				return $q.reject(errMsg);
			});
		}
	}

})();
